export const AUTO_CYCLE_IN_MS = 7 * 1000; // 7 seconds

// Desktop (md+) arrow navigation
export const ARROW_GUTTER_MD_SPACING = 2;
export const ARROW_BUTTON_WIDTH_SPACING = 5;
export const GAP_AFTER_ARROW_SPACING = 6.5;

// Mobile (xs)
export const MOBILE_IMAGE_MAX_HEIGHT_PX = 330;

// Tablet (sm)
export const TABLET_IMAGE_WIDTH_PX = 594;
export const TABLET_IMAGE_HEIGHT_PX = 330;
export const TABLET_TEXT_LEFT_PX = 24;
export const TABLET_TEXT_MAX_WIDTH_PX = 360;
export const TABLET_IMAGE_MIN_LEFT_PX = 240;

// Desktop (md+)
export const DESKTOP_IMAGE_HEIGHT_PX = 400;
export const DESKTOP_IMAGE_MIN_WIDTH_PX = 720;
export const DESKTOP_TEXT_MAX_WIDTH_PX = 475;

export const DEFAULT_CAROUSEL_HEIGHT = {
  desktop: 400,
  tablet: TABLET_IMAGE_HEIGHT_PX,
  mobile: 500,
};

// Optional logo asset
export const LOGO_ASSET_DESKTOP_MAX_WIDTH_PX = 320;
export const LOGO_ASSET_DESKTOP_MAX_HEIGHT_PX = 60;
export const LOGO_ASSET_MOBILE_MAX_WIDTH_PX = 220;
export const LOGO_ASSET_MOBILE_MAX_HEIGHT_PX = 40;
export const LOGO_ASSET_MOBILE_RESERVED_HEIGHT_PX = 40;
export const LOGO_ASSET_TITLE_GAP_PX = 12;
export const MOBILE_LOGO_SLOT_TOTAL_PX =
  LOGO_ASSET_MOBILE_RESERVED_HEIGHT_PX + LOGO_ASSET_TITLE_GAP_PX;

export const HOME_HERO_MOBILE_CAROUSEL_HEIGHT_PX =
  DEFAULT_CAROUSEL_HEIGHT.mobile + MOBILE_LOGO_SLOT_TOTAL_PX;
